export enum FeatureToggle {
  cashflow = 'rt_cashflow',
  cashflowCheckoutDiscrepancyAudits = 'rt_cashflow_checkout_discrepancy_audits',
}
